import { createContext, useContext, type ReactNode } from 'react'
import type { SupabaseClient } from '@supabase/supabase-js'
import { supabase } from '../lib/supabase'

const SupabaseContext = createContext<SupabaseClient>(supabase)

interface SupabaseProviderProps {
  client: SupabaseClient
  children: ReactNode
}

export function SupabaseProvider({ client, children }: SupabaseProviderProps) {
  return <SupabaseContext.Provider value={client}>{children}</SupabaseContext.Provider>
}

export function useSupabase() {
  return useContext(SupabaseContext)
}
